import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Expenses from '../../../Components/pages/expenses/Expenses';
import classes from './ExpensesPage.module.scss';
import { getConstants } from '../../../actions/constFromApi';

export default function ExpensesPage() {
  const dispatch = useDispatch();
  const constants = useSelector((state) => state.constFromApi);

  const [searchParams] = useSearchParams();
  const [key, setKey] = useState(1);

  useEffect(() => {
    if (searchParams.has('status') && !searchParams.has('page')) {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!constants.clients || !constants.worktypes) dispatch(getConstants(true));
  }, [constants]);

  return (
    <section className={`${classes.pageContainer}`}>
      <Expenses key={key} />
    </section>
  );
}
